






import CoHtml from '../co-html/CoHtml.vue';
export default {
    name: 'CoEditorContent',
    components: {
        CoHtml,
    },
    props: {
        content: {
            type: String,
            default: '',
        },
    },
};
